import React from 'react';
import { MailIcon, ShieldCheckIcon } from 'lucide-react';
import { SUPPORT_EMAIL } from '../data/offer';
export function Guarantee() {
  return <section className="w-full bg-carbon-800 py-16 sm:py-20 lg:py-28" aria-labelledby="guarantee-heading" data-id="element-118" data-mp="1o3dnadhb4fro">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-119" data-mp="1x4bsv07e8vcd">
        <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full border border-mint-deep/40 bg-mint/10" data-id="element-120" data-mp="1x54qnbodkaid">
          <ShieldCheckIcon className="h-8 w-8 text-mint" strokeWidth={1.5} aria-hidden="true" data-id="element-121" data-mp="14fo24p3vldrf" />
        </span>
        <h2 id="guarantee-heading" className="display-tight mt-7 font-display text-[28px] uppercase text-paper sm:text-[42px]" data-id="element-122" data-mp="1j4aganhrnzh2">
          10-day
          <span className="block text-mint" data-id="element-123" data-mp="1ebr5fyagrify">money-back guarantee</span>
        </h2>
        <p className="mt-6 text-base leading-relaxed text-paper-dim sm:text-lg" data-id="element-124" data-mp="qmewmzj1tce6">
          Use the PDFs with your athletes for 10 days. If you don’t feel more confident, if your
          sessions don’t improve, or if you don’t save hours of planning time —{' '}
          <span className="text-paper" data-id="element-125" data-mp="txt7gwtgkfbt">we don’t want your money.</span> Write to us within 10 days
          and you get a 100% refund, no questions asked.
        </p>

        <div className="mt-10 inline-flex w-full flex-col items-center gap-2 rounded-xl border border-carbon-line bg-carbon-900 px-5 py-6 sm:w-auto sm:px-8" data-id="element-126" data-mp="12qwrxp2itsfy">
          <span className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.18em] text-mint" data-id="element-127" data-mp="628fd89kqxdx">
            <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-128" data-mp="b1uqnc5ue3k3" />
            Customer support
          </span>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="break-all text-base font-semibold text-paper underline decoration-mint-deep underline-offset-4 transition-colors duration-150 ease-out hover:text-mint" data-id="element-129" data-mp="f3g8lbx8h815">
            {SUPPORT_EMAIL}
          </a>
          <span className="text-sm text-paper-dim" data-id="element-130" data-mp="1vdr29t5mjbfp">We reply to every email.</span>
        </div>
      </div>
    </section>;
}